export default function Pandas_AnalyzingData() {
  return <div>Pandas_AnalyzingData </div>;
}
